import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const MobileHistory = ({ kind, id }) => {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get(`/admin/mobile-history/${kind}/${id}`).then((r) => setRows(r.data)).catch(() => setRows([])); }, [kind, id]);
  if (!rows) return null;
  return (
    <div data-testid={`mobile-history-${kind}`}>
      <h4 className="mb-2 mt-5 text-[11px] font-bold uppercase tracking-wider text-[#6B7F74]">Mobile number history ({rows.length})</h4>
      {!rows.length && <p className="text-sm text-[#6B7F74]">No changes recorded yet.</p>}
      {rows.map((r, i) => (
        <div key={i} className="mb-2 rounded-xl border border-[#E3E6DD] p-3 text-sm" data-testid={`mobile-history-row-${i}`}>
          <p><b>{r.old ? `${r.old} → ${r.new}` : `Added ${r.new}`}</b>{r.verified ? <span className="ml-2 text-xs font-bold text-[#1F7A50]">✓ SMS verified</span> : <span className="ml-2 text-xs text-[#B4401F]">not verified</span>}</p>
          <p className="text-xs text-[#6B7F74]">{new Date(r.at).toLocaleString("en-IN")} · by {r.by}</p>
        </div>
      ))}
    </div>
  );
};
